var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.logoStyles},[_c('router-link',{attrs:{"to":{ name: 'HomePage' }}},[_c('img',{class:_vm.imgStyles,attrs:{"src":require("@/assets/icons/new-ui/left-navbar/ring-logo.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }